import { render, staticRenderFns } from "./404Pro.vue?vue&type=template&id=454f0361&scoped=true"
import script from "./404Pro.vue?vue&type=script&lang=js"
export * from "./404Pro.vue?vue&type=script&lang=js"
import style0 from "./404Pro.vue?vue&type=style&index=0&id=454f0361&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454f0361",
  null
  
)

export default component.exports